export * from './resource.service';